import { DataService } from 'api/DataService'

import {
  InvoiceTimelineResponse,
  TimelineRecord
} from '../types/invoiceTimeline'

/**
 * SC-10890: busca a timeline de uma cobrança.
 *
 * Endpoint dedicado, chamado quando o accordion abre — e não embutido no payload
 * de `/billings/:uuid/details`, que já é grande e é refetchado a cada ação no
 * modal (reenvio, marcar como paga, editar, estornar).
 */
export const fetchInvoiceTimeline = async (
  billingUuid: string
): Promise<InvoiceTimelineResponse | null> => {
  const response = await DataService({
    url: `/v1/billings/${billingUuid}/timeline`,
    type: 'GET'
  })

  if (!response || response.error) return null

  const body = response.data ?? response
  if (!body) return null

  return {
    dueDate: body.due_date ?? null,
    statistics: {
      openCount: body.statistics?.open_count ?? 0,
      firstOpenedAt: body.statistics?.first_opened_at ?? null,
      lastOpenedAt: body.statistics?.last_opened_at ?? null,
      replyCount: body.statistics?.reply_count ?? 0,
      hasDetailedOpenHistory:
        body.statistics?.has_detailed_open_history ?? false
    },
    // Normalização defensiva: `records` nulo não pode derrubar a tela.
    records: Array.isArray(body.records)
      ? body.records.map(constructorTimelineRecord)
      : []
  }
}

const constructorTimelineRecord = (data: any): TimelineRecord => ({
  kind: data?.kind,
  uuid: data?.uuid,
  occurredAt: data?.occurred_at ?? null,
  campaign: data?.campaign,
  campaignLabel: data?.campaign_label,
  medium: data?.medium,
  status: data?.status,
  statusLabel: data?.status_label,
  contactUsed: data?.contact_used ?? null,
  resendable: data?.resendable,
  scheduledFor: data?.scheduled_for ?? null,
  channel: data?.channel,
  channelLabel: data?.channel_label,
  eventKind: data?.event_kind,
  eventKindLabel: data?.event_kind_label,
  source: data?.source ?? null,
  body: data?.body ?? null,
  correlation: data?.correlation,
  correlationLabel: data?.correlation_label
})
